import CitySalaryPageTemplate from "@/components/CitySalaryPageTemplate";
import { CITY_SALARY_DATA } from "@/data/citySalaryData";

export default function ProductManagerBangalore() {
  return <CitySalaryPageTemplate data={CITY_SALARY_DATA["product-manager-bangalore"]} />;
}
